import CustomError from "@components/Error/CustomError";
import DecodingAsiaPageContent from "@pages/Newsletter/DecodingAsia/DecodingAsiaPageContent";
import { DecodingAsiaPageContext } from "@pages/Newsletter/DecodingAsia/utils/types";
import { useRouteContext } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

const DecodingAsiaPage = (): React.ReactElement => {
  const { context } = useRouteContext<DecodingAsiaPageContext>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return <DecodingAsiaPageContent {...context.payload.data} />;
};

export default DecodingAsiaPage;
